"use client";

import { useState, useEffect } from "react";
import AdminBar from "../adminBar/AdminBar";
import TopBar from "./TopBar";

export default function AdminBarOrTopBar() {
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        const cookie = document.cookie.split(";").find(c => c.trim().startsWith("admin_preview="));
        setIsAdmin(!!cookie?.trim().split("=")[1]);
    }, []);

    return isAdmin ? <AdminBar /> : <TopBar />;
}
